import { useState } from 'react';
import { ShoppingCart, CirclePlus } from 'lucide-react';

import { CART_CHANNELS } from './enums';
import ViewCartForCardPage from './ViewCartForCardPage';

import { Button } from '@/components/ui/button';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import Spinner from '@/components/common/Spinner';
import Error from '@/components/common/Error';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import { useCard } from '@/data/card';
import { usePostCart, useCardCart } from '@/data/cart';

const ListCartsForCardPage = () => {
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState(null);
  const card = useCard();
  const postCart = usePostCart();
  const cardCart = useCardCart();

  const handleCreateCart = async () => {
    try {
      setSubmitting(true);
      const payload = {
        cardId: card.data.id,
        channel: CART_CHANNELS.CARD
      };
      await postCart(payload);
      await cardCart.mutate();
    } catch (err) {
      setApiError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (cardCart.isLoading && !cardCart.data) {
    return (
      <div>
        <h2 className="text-xl font-bold mb-4">Custom Cart</h2>
        <div className="flex justify-center items-center h-[200px]">
          <Spinner />
        </div>
      </div>
    );
  }

  if (!cardCart.data) {
    return (
      <div>
        <Alert className="mb-4">
          <ShoppingCart size={18} />
          <AlertTitle>Cart Mode</AlertTitle>
          <AlertDescription>
            Your card is currently in Cart mode. This means you can build a
            custom cart below and when you tap your card on someones phone, it
            will redirect them to this custom cart.
          </AlertDescription>
        </Alert>
        <h2 className="text-xl font-bold">Custom Cart</h2>
        <Empty>
          <EmptyIcon>
            <ShoppingCart />
          </EmptyIcon>
          <EmptyTitle>No Cart Found</EmptyTitle>
          <EmptyDescription className="py-4">
            <Button
              variant="outline"
              size="sm"
              onClick={handleCreateCart}
              disabled={submitting}
            >
              <CirclePlus size={16} className="mr-2" />
              Create Cart
            </Button>
          </EmptyDescription>
        </Empty>
        {apiError && <Error error={apiError} />}
      </div>
    );
  }

  return (
    <div className="pt-4">
      <ViewCartForCardPage cartId={cardCart.data.id} />
    </div>
  );
};

export default ListCartsForCardPage;
